export enum CollaborationButtonAction {
  View = 'View',
  RequestAccess = 'RequestAccess',
}
